import React from 'react'
import styled from '@emotion/styled'
import ConfirmationModal, { ModalDescription } from './ConfirmationModal'

export const OUTSTANDING_INVOICES_ERROR =
  'Cannot disconnect Stripe while there are outstanding invoices'

interface OutstandingInvoicesModalProps {
  isOpen: boolean
  onGoToInvoices: () => void
  onCancel: () => void
}

export const OutstandingInvoicesModal = ({
  isOpen,
  onGoToInvoices,
  onCancel
}: OutstandingInvoicesModalProps) => (
  <ConfirmationModal
    title='Outstanding invoices'
    confirmLabel='Go to invoices'
    confirmVariant='default'
    isOpen={isOpen}
    onOk={onGoToInvoices}
    onCancel={onCancel}
  >
    <ModalDescription>
      Before you can disconnect your Stripe Connected account, please make sure
      all outstanding invoices are settled.
    </ModalDescription>
    <ModalFootnote>
      Contact{' '}
      <ContactLink href='mailto:finance@slerp.com'>
        finance@slerp.com
      </ContactLink>{' '}
      if you have any questions.
    </ModalFootnote>
  </ConfirmationModal>
)

const ModalFootnote = styled(ModalDescription)`
  font-style: italic;
  font-size: 12px;
`

const ContactLink = styled.a`
  color: #2f54eb;
  text-decoration: underline;
`
